export const REMAINDERS = {
  CREATE: "/remainders",
  LIST: "/remainders/list",
};
